import MotifRefusAdmissionFormController from './motif.refus.admission.form.controller';

export default {
    template: require('./motif.refus.admission.form.html'),
    controller: MotifRefusAdmissionFormController
};
